"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _DateInput = _interopRequireDefault(require("./DateInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateInputGroup = function DateInputGroup(_ref) {
  var showCalendarIcon = _ref.showCalendarIcon,
      inputFocus = _ref.inputFocus,
      handleClickDateInput = _ref.handleClickDateInput,
      fromDate = _ref.fromDate,
      toDate = _ref.toDate,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      handleChangeDate = _ref.handleChangeDate,
      startDatePlaceholder = _ref.startDatePlaceholder,
      endDatePlaceholder = _ref.endDatePlaceholder,
      dateFormat = _ref.dateFormat,
      isSingle = _ref.isSingle,
      onFocus = _ref.onFocus,
      nonFocusable = _ref.nonFocusable,
      dateInputSeperator = _ref.dateInputSeperator,
      setSelectedInput = _ref.setSelectedInput;

  function handleClickFromInput() {
    handleClickDateInput('from');
  }

  function handleClickToInput() {
    handleClickDateInput('to');
  }

  function getDateFromValue(action, value) {
    if (action === 'prev') {
      return (0, _dayjs.default)(value).subtract(1, 'day');
    }

    return (0, _dayjs.default)(value).add(1, 'day');
  }

  function handleChangeFromDate(action, value) {
    var date = getDateFromValue(action, value);
    handleChangeDate(date, 'from');
  }

  function handleChangeToDate(action, value) {
    var date = getDateFromValue(action, value);
    handleChangeDate(date, 'to');
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-input"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-date-group"
  }, /*#__PURE__*/_react.default.createElement(_DateInput.default, {
    handleClickDateInput: handleClickFromInput,
    showIcon: true,
    tabIndex: nonFocusable ? '-1' : '0',
    value: fromDate,
    placeholder: startDatePlaceholder,
    handleChangeDate: handleChangeFromDate,
    dateFormat: dateFormat,
    isSingle: isSingle,
    name: "START_DATE",
    onFocus: onFocus,
    nonFocusable: nonFocusable,
    minDate: minDate,
    maxDate: maxDate,
    setSelectedInput: setSelectedInput
  }), !isSingle && dateInputSeperator && /*#__PURE__*/_react.default.createElement("div", {
    className: "date-input-separator"
  }, dateInputSeperator), !isSingle && /*#__PURE__*/_react.default.createElement(_DateInput.default, {
    handleClickDateInput: handleClickToInput,
    tabIndex: "0",
    value: toDate,
    placeholder: endDatePlaceholder,
    handleChangeDate: handleChangeToDate,
    dateFormat: dateFormat,
    name: "END_DATE",
    nonFocusable: nonFocusable,
    minDate: minDate,
    maxDate: maxDate,
    onFocus: onFocus,
    fromDate: fromDate,
    setSelectedInput: setSelectedInput
  })));
};

DateInputGroup.propTypes = {
  handleClickDateInput: _propTypes.default.func,
  showCalendarIcon: _propTypes.default.bool,
  inputFocus: _propTypes.default.string,
  fromDate: _propTypes.default.instanceOf(Date),
  toDate: _propTypes.default.instanceOf(Date),
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  handleChangeDate: _propTypes.default.func,
  startDatePlaceholder: _propTypes.default.string,
  endDatePlaceholder: _propTypes.default.string,
  dateFormat: _propTypes.default.string,
  isSingle: _propTypes.default.bool,
  onFocus: _propTypes.default.func,
  nonFocusable: _propTypes.default.bool,
  dateInputSeperator: _propTypes.default.node,
  setSelectedInput: _propTypes.default.func
};
DateInputGroup.defaultProps = {
  handleClickDateInput: function handleClickDateInput() {},
  showCalendarIcon: false,
  inputFocus: null,
  fromDate: null,
  toDate: null,
  minDate: null,
  maxDate: null,
  handleChangeDate: function handleChangeDate() {},
  startDatePlaceholder: null,
  endDatePlaceholder: null,
  dateFormat: '',
  isSingle: false,
  onFocus: function onFocus() {},
  nonFocusable: false,
  dateInputSeperator: null,
  setSelectedInput: function setSelectedInput() {}
};
var _default = DateInputGroup;
exports.default = _default;